import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Sidebar from '../components/Sidebar';
import TopNav from '../components/TopNav';
import { announcementService } from '../services/api';
import { useNotification } from '../contexts/NotificationContext';
import { Card, Badge, EmptyState, Spinner } from '../components/ui';

const AUDIENCE_TONE = { all: 'blue', students: 'green', teachers: 'purple', parents: 'yellow' };

function Announcements() {
  const { addNotification } = useNotification();
  const { t } = useTranslation();
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    announcementService.getAnnouncements()
      .then((res) => {
        const data = res.data;
        setAnnouncements(Array.isArray(data) ? data : data.results || []);
      })
      .catch(() => addNotification(t('Failed to load announcements'), 'error'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen bg-surface-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <TopNav title={t('Announcements')} subtitle={t('Notices from the school')} />
        <main className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="p-12 flex justify-center"><Spinner /></div>
          ) : announcements.length === 0 ? (
            <Card><EmptyState title={t('No announcements yet')} /></Card>
          ) : (
            <div className="max-w-3xl space-y-3">
              {announcements.map((a) => (
                <Card key={a.id} padded={false} className="p-5">
                  <div className="flex items-center gap-2 flex-wrap mb-1.5">
                    <h3 className="font-semibold text-gray-900">{a.title}</h3>
                    <Badge tone={AUDIENCE_TONE[a.audience]}>{t(a.audience)}</Badge>
                    {a.grade_detail && <Badge tone="gray">{a.grade_detail.name}</Badge>}
                  </div>
                  <p className="text-sm text-gray-700 whitespace-pre-wrap">{a.body}</p>
                  <p className="text-xs text-gray-400 mt-3">
                    {t('By {{name}}', { name: a.created_by ? `${a.created_by.first_name} ${a.created_by.last_name}` : t('system') })}
                    {' · '}{new Date(a.created_at).toLocaleString()}
                  </p>
                </Card>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}

export default Announcements;
